import type { UserWithMemberships } from '../../../api/users';
import { isProfileComplete } from '../../../utils/profileValidation';

export function userHasActiveCondominiumMembership(
  user: UserWithMemberships,
  condominiumId: string,
): boolean {
  return user.memberships.some(
    (membership) =>
      membership.condominiumId === condominiumId && membership.status === 'ACTIVE',
  );
}

export function filterUsersForApartmentAssociation(
  users: UserWithMemberships[],
  condominiumId: string,
): UserWithMemberships[] {
  return users.filter((user) => {
    if (
      !isProfileComplete({
        firstName: user.firstName,
        lastName: user.lastName,
        documentNumber: user.documentNumber,
        phone: user.phone,
      })
    ) {
      return false;
    }
    return userHasActiveCondominiumMembership(user, condominiumId);
  });
}
